import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $CardContentThumbnailWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  // padding: ${spacing('xs')} ${spacing('sm')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('lg')};
  max-width: ${spacing(10)};
  height: ${spacing(10)};
  overflow: hidden;
`;

export const $CardContentThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  && svg {
    max-width: ${spacing(9)};
    max-height: ${spacing(9)};
  }

  && img {
    object-fit: contain;
    max-height: ${spacing(16)};
    max-width: ${rem(60)};
  }
`;

export const $CardContentSmallThumbnailWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  // padding: ${spacing('xs')} ${spacing('sm')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('sm')};
  max-width: ${spacing(5)};
  height: ${spacing(5)};
  overflow: hidden;
`;

export const $CardContentSmallThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  && svg {
    max-width: ${spacing(5)};
    max-height: ${spacing(5)};
  }

  && img {
    object-fit: contain;
    max-height: ${spacing(9)};
    max-width: ${spacing(9)};
  }
`;

export const $CardContentDescription = styled.div`
  flex: 2;
`;

export const $CardContentProductName = styled.div``;

export const $CardContentQuantity = styled.div`
  color: ${({ theme }) => theme.colors.tertiary};
`;
